import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

// components
import DayPicker from 'react-day-picker';

// lib
import formatDate from '../../../lib/formatDate';

class DatePicker extends React.Component {
  static propTypes = {
    input: PropTypes.instanceOf(Object).isRequired
  };

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map({
      inputReference: null,
      insideClick: false,
      show: false
    }) };
  }

  componentWillUnmount() {
    clearTimeout(this._clickTimeout);
  }

  render() {
    const { input: { value } } = this.props;

    const displayValue = value ? formatDate(value) : '';

    return (
      <div className={ classNames('date-picker', this.props.className) } onMouseDown={ this._handleInsideClick }>
        <input className='form__field date-picker__field'
          onBlur={ this._handleBlur }
          onClick={ this._handleFocus }
          readOnly={ true }
          ref={ this._setInputReference }
          type='text'
          value={ displayValue } />
        <i className='fa fa-calendar-o date-picker__icon' onClick={ this._handleFocus } />
        { this._renderDayPicker() }
      </div>
    );
  }

  // private

  _clickTimeout       = this._clickTimeout.bind(this);
  _handleBlur         = this._handleBlur.bind(this);
  _handleDayClick     = this._handleDayClick.bind(this);
  _handleFocus        = this._handleFocus.bind(this);
  _handleInsideClick  = this._handleInsideClick.bind(this);
  _setInputReference  = this._setInputReference.bind(this);

  _clickTimeout() {
    this.setState({ data: this.state.data.set('insideClick', false) });
  }

  _handleBlur() {
    if (!this.state.data.get('insideClick')) {
      this._handleHideDayPicker();
    } else if (this.state.data.get('show')) {
      this.state.data.get('inputReference').focus();
    }
  }

  _handleDayClick(day) {
    const { input: { onChange } } = this.props;

    onChange(day);
    this.state.data.get('inputReference').blur();
    this._handleHideDayPicker();
  }

  _handleFocus() {
    this.setState({ data: this.state.data.set('show', true) });
  }

  _handleInsideClick() {
    this.setState({ data: this.state.data.set('insideClick', true) });

    setTimeout(this._clickTimeout, 0);
  }
  _handleHideDayPicker() {
    return this.setState({ data: this.state.data.set('show', false) });
  }
  _renderDayPicker() {
    let element = null;

    if (this.state.data.get('show')) {
      element = (
        <div className='day-picker-container'>
          <div className='day-picker'>
            <DayPicker onDayClick={ this._handleDayClick } />
          </div>
        </div>
      );
    }

    return element;
  }

  _setInputReference(element) {
    this.setState({ data: this.state.data.set('inputReference', element) });
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./app/components/shared/form/_DatePicker.jsx